require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-bootstrap-add-elements-within-your-bootstrap-wells.json") })
        }
      }, "path---front-end-libraries-bootstrap-add-elements-within-your-bootstrap-wells");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-bootstrap-add-elements-within-your-bootstrap-wells!./.cache/json/front-end-libraries-bootstrap-add-elements-within-your-bootstrap-wells.json
// module id = 1986
// module chunks = 231608221292675